import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext } from '@tanstack/react-router'

import { zmpSettingQueryOptions } from '@/common/hooks/useGetZMPSetting'
import RouterRoot from '@/common/router/router-root'
import type { StorefrontConfig } from '@/common/storefront/storefront.config'

export interface RouterContext {
  queryClient: QueryClient
  storefront: StorefrontConfig
}

export const Route = createRootRouteWithContext<RouterContext>()({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(zmpSettingQueryOptions),
  head: ({ loaderData }) => {
    const meta = loaderData?.meta
    const title = meta?.site_name
      ? `${meta?.title ?? ''} | ${meta.site_name}`
      : meta?.title

    return {
      meta: [
        { title },
        { name: 'description', content: meta?.description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: meta?.description },
        { property: 'og:image', content: meta?.og_image },
        { property: 'og:image:height', content: '630' },
        { property: 'og:image:width', content: '1200' },
      ],
    }
  },
  component: RouterRoot,
  notFoundComponent: () => <div>Không tìm thấy trang</div>,
})
